import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import starFilledIcon from 'assets/images/static-icons/star-filled.svg';
import starHollowIcon from 'assets/images/static-icons/star-hollow.svg';
import { useTranslation } from 'react-i18next';

const RatingStarField = ({
  value,
  numOfStars,
  displayName,
  classes,
  handleChange,
  required,
  disabled,
}) => {
  const { t } = useTranslation();
  const [fillStarCount, setFillStarCount] = useState(0);

  useEffect(() => {
    setFillStarCount(value);
  }, [numOfStars]);

  return (
    <div className={`custom-input-box${classes ? ' ' + classes : ''}`}>
      {displayName && (
        <label>
          {t(displayName)}
          {required && <span className='lh-1 theme-size-1_5 theme-text-red-1 px-1'>*</span>}
        </label>
      )}
      <div className='custom-input-field'>
        {Array.from(Array(numOfStars ?? 0).keys()).map((_, index) => (
          <img
            key={index}
            src={index < fillStarCount ? starFilledIcon : starHollowIcon}
            onClick={() => {
              if (!disabled) {
                setFillStarCount(index + 1);
                handleChange(index + 1);
              }
            }}
            style={{ height: '2rem' }}
            className={disabled ? 'svg-grey' : ''}
          />
        ))}
      </div>
    </div>
  );
};

RatingStarField.propTypes = {
  displayName: PropTypes.string,
  value: PropTypes.number,
  numOfStars: PropTypes.number,
  handleChange: PropTypes.func,
  classes: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default RatingStarField;
